import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=405ed2fa&scoped=true"
import script from "./Article.vue?vue&type=script&lang=js"
export * from "./Article.vue?vue&type=script&lang=js"
import style0 from "./Article.vue?vue&type=style&index=0&id=405ed2fa&prod&lang=scss&scoped=true"
import style1 from "./Article.vue?vue&type=style&index=1&id=405ed2fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405ed2fa",
  null
  
)

export default component.exports